import storageApi from '@/api/modules/storage';
import UUID from '@/utils/uuid';
import { MessageBox } from 'element-ui';

/**
 * 使用 XMLHttpRequest 进行 PUT 上传（支持进度追踪）
 * @param {File} file 文件对象
 * @param {string} putUrl 预签名PUT URL
 * @param {object} callbacks { onProgress, onError, onComplete }
 */
function putUpload(file, putUrl, callbacks = {}) {
  const xhr = new XMLHttpRequest();

  xhr.upload.addEventListener('progress', (e) => {
    if (e.lengthComputable && typeof callbacks.onProgress === 'function') {
      callbacks.onProgress({ total: { percent: Math.round((e.loaded / e.total) * 100) } });
    }
  });

  xhr.addEventListener('load', () => {
    if (xhr.status >= 200 && xhr.status < 300) {
      if (typeof callbacks.onComplete === 'function') {
        callbacks.onComplete();
      }
    } else {
      if (typeof callbacks.onError === 'function') {
        callbacks.onError(new Error(`Upload failed with status ${xhr.status}`));
      }
    }
  });

  xhr.addEventListener('error', () => {
    if (typeof callbacks.onError === 'function') {
      callbacks.onError(new Error('Network error during upload'));
    }
  });

  xhr.open('PUT', putUrl);
  xhr.send(file);
}

export default {
  // 上传多文件
  async uploadFiles(files, options = {}) {
    let count = 0;
    let total = files.length;
    let resFiles = [];
    options.bucket = options.bucket || 'vybbasevrv2';
    options.size = options.size ? options.size : 20;

    return new Promise((resolve, reject) => {
      files = Array.from(files);
      let maxOverFiles = files.filter((item) => item.size > options.size * 1024 * 1024);
      if (maxOverFiles.length) {
        let msg = `【${maxOverFiles[0].name}】文件体积超过限制，上限${options.size}M`;
        reject(msg);
        MessageBox.alert(msg, '提示', { type: 'error' });
        return;
      }
      files = files.filter((item) => item.size <= options.size * 1024 * 1024);
      let queue = files.splice(0, 5);
      doUpload(queue);

      function doUpload(queue) {
        queue.forEach(async (file) => {
          try {
            let key = UUID.generate() + Date.now();
            let res = await storageApi.getUploadFileToken({
              bucket: options.bucket,
              key: key,
            });
            let domain = res.data.protocol + '://' + res.data.domain + '/';
            let putUrl = res.data.token;

            putUpload(file, putUrl, {
              onProgress(res) {
                if (typeof options.onProgress === 'function') {
                  res.index = file.index;
                  options.onProgress(res);
                }
              },
              onError(err) {
                reject(err);
              },
              onComplete() {
                count++;
                let result = {
                  key: key,
                  preview: domain + key,
                  name: file.name,
                  index: file.index,
                };
                resFiles.push(result);

                if (files.length) {
                  doUpload(files.splice(0, 1));
                }

                if (typeof options.onSuccess === 'function') {
                  options.onSuccess(result);
                }
                if (typeof options.onComplete === 'function' && total === count) {
                  options.onComplete(resFiles);
                }
                if (total === count) {
                  resolve(resFiles);
                }
              },
            });
          } catch (err) {
            reject(err);
          }
        });
      }
    });
  },

  // 上传单文件
  async uploadFile(file, { progress = () => {} } = {}, bucket = 'vybbasevrv2') {
    let key = UUID.generate() + Date.now();
    let res = await storageApi.getUploadFileToken({ bucket, key: key });
    let domain = res.data.protocol + '://' + res.data.domain + '/';
    let putUrl = res.data.token;

    return new Promise((resolve, reject) => {
      putUpload(file, putUrl, {
        onProgress(res) {
          progress(res);
        },
        onError(err) {
          reject(err);
        },
        onComplete() {
          resolve({
            preview: domain + key,
            name: file.name,
            key: key,
          });
        },
      });
    });
  },

  // 上传单图
  async uploadImage(file, options = {}) {
    let key = UUID.generate() + Date.now();
    let res = await storageApi.getUploadFileToken({
      bucket: options.bucket || 'vybbasevrv2',
      key: key,
    });
    let domain = res.data.protocol + '://' + res.data.domain + '/';
    let putUrl = res.data.token;

    return new Promise((resolve, reject) => {
      putUpload(file, putUrl, {
        onError(err) {
          reject(err);
        },
        onComplete() {
          resolve({
            preview: domain + key,
            name: file.name,
            key: key,
          });
        },
      });
    });
  },
};
